// Server-issued session tokens (security phase 1).
//
// After a customer logs in with a mobile OTP (or an admin logs in) the database hands
// back a random token. We keep it in localStorage and send it with every database
// request in the `x-app-session` header, so the server can tell WHO is calling
// (it exposes the header to SQL as request.headers). Only a hash of the token is
// stored on the server; a lost token can be revoked with app_logout().
export const CUSTOMER_SESSION_KEY = 'gs_session';
export const ADMIN_SESSION_KEY = 'vipgarg_admin_session';
export const SESSION_HEADER = 'x-app-session';

const read = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const getCustomerSession = (): string | null => read(CUSTOMER_SESSION_KEY);

export const setCustomerSession = (token: string | null | undefined): void => {
  try {
    if (token) localStorage.setItem(CUSTOMER_SESSION_KEY, token);
    else localStorage.removeItem(CUSTOMER_SESSION_KEY);
  } catch {
    // storage unavailable (private mode etc.) -- the user simply isn't kept logged in
  }
};

/** Admin screens act as the admin; everything else acts as the logged-in customer. */
export const getActiveSessionToken = (): string | null => {
  const onAdminArea = typeof window !== 'undefined' && window.location.pathname.startsWith('/vipgarg-admin');
  return onAdminArea ? read(ADMIN_SESSION_KEY) : getCustomerSession();
};

/**
 * fetch() that adds the session header to database (PostgREST) requests only.
 * Edge functions are left alone: their CORS rules don't allow the header yet.
 */
export const fetchWithSession: typeof fetch = (input, init) => {
  const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
  if (!url.includes('/rest/v1/')) return fetch(input, init);

  const token = getActiveSessionToken();
  if (!token) return fetch(input, init);

  const headers = new Headers(init?.headers ?? (typeof input === 'object' && 'headers' in input ? (input as Request).headers : undefined));
  headers.set(SESSION_HEADER, token);
  return fetch(input, { ...init, headers });
};
